import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './assets/styles/global.css'

Vue.config.productionTip = false

// 挂载 axios 到 Vue 原型，组件中通过 this.$axios 访问
Vue.prototype.$axios = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
